// extracted by mini-css-extract-plugin
export var carrierIcon = "_vh-0";
export var carrierLogo = "_vh-1";
export var detailsSection = "_vh-2";